export default __webpack_public_path__ + "static/media/location.4140aa78.svg";